import moment from 'moment';
import { message } from 'antd';
import uniq from 'lodash/uniq';
import omit from 'lodash/omit';
import get from 'lodash/get';
import * as partnersServices from '../services/partners';

const RESOURCE = 'partners';
const transfromDocument = (record) => {
  if (record.created) {
    const createdAt = record.created;
    record.created = moment.unix(createdAt);
  }
  if (record.updatedAt) {
    const updatedAt = record.updatedAt;
    record.updatedAt = moment.unix(updatedAt);
  }
  if(record.card_active){
    record.card_active = record.card_active === 1 ? true : false
  }

  if (record.logo && Array.isArray(record.logo)) {
    record.logo =
      record.logo && record.logo.length > 0
        ? record.logo
          .filter((i) => i && i !== '')
          .map((i, idx) => ({
            uid: `${record.id}${idx + 1}`,
            name: `${record.name}-${idx}` || '',
            status: 'done',
            url: i,
          }))
        : [];
  } else if (record.logo && typeof record.logo === 'string') {
    record.logo = [
      {
        uid: `${record.id}`,
        name: `${record.name}` || '',
        status: 'done',
        url: record.logo,
      },
    ];
  }

  if (record.card_image && Array.isArray(record.card_image)) {
    record.card_image =
      record.card_image && record.card_image.length > 0
        ? record.card_image
          .filter((i) => i && i !== '')
          .map((i, idx) => ({
            uid: `${record.id}${idx + 1}`,
            name: `${record.name}-${idx}` || '',
            status: 'done',
            url: i,
          }))
        : [];
  } else if (record.card_image && typeof record.card_image === 'string') {
    record.card_image = [
      {
        uid: `${record.id}`,
        name: `${record.name}` || '',
        status: 'done',
        url: record.card_image,
      },
    ];
  }

  if (record.avatar && Array.isArray(record.avatar)) {
    record.avatar =
      record.avatar && record.avatar.length > 0
        ? record.avatar
          .filter((i) => i && i !== '')
          .map((i, idx) => ({
            uid: `${record.id}${idx + 1}`,
            name: `${record.name}-${idx}` || '',
            status: 'done',
            url: i,
          }))
        : [];
  } else if (record.avatar && typeof record.avatar === 'string') {
    record.avatar = [
      {
        uid: `${record.id}`,
        name: `${record.name}` || '',
        status: 'done',
        url: record.avatar,
      },
    ];
  }
  if (record.events) {
    let temps = [];
    for (let key in record.events) {
      temps.push(key);
    }
    record.events = temps;
  }
  return record;
};

export default {
  namespace: 'partners',

  state: {
    data: {
      list: [],
      pagination: {
        anchor: '',
        listAnchor: {
          1: '',
        },
      },
    },
    submitting: false,
    formTitle: '',
    formID: '',
    formVisible: false,
    formData: {},
  },

  effects: {
    *fetch({ payload, callback }, { call, put }) {
      let list = [];
      try {
        const listPartner = yield call(partnersServices.getList, payload);
        console.log("$$listPartner",listPartner)
        
        let ids = []
        listPartner.partners
          .filter(item => item.refer_by)
          .map(item => ids.push(item.refer_by))
        ids = uniq(ids).join(",")
        payload.cxzczx = ids

        const response = yield call(partnersServices.getList, payload);

        if (response) {
          if (response[RESOURCE]) {
            list = response[RESOURCE].map((item) => {
              transfromDocument(item);
              return item;
            });
          }
          yield put({
            type: 'save',
            payload: {
              list,
              pagination: {
                total: response.total,
                anchor: get(response, ['anchor'], ''),
                listAnchor: {
                  [((payload && payload.current) || 1) + 1]: get(
                    response,
                    ['anchor'],
                    '',
                  ),
                },
              },
            },
          });
        }
      } catch (error) {
        console.log('*fetch -> error', error);
      }
      if (callback) {
        callback(list);
      }
    },

    *loadForm({ payload, callback }, { put }) {
      yield put({
        type: 'changeFormVisible',
        payload: true,
      });

      yield [
        put({
          type: 'saveFormType',
          payload: payload.type,
        }),
        put({
          type: 'saveFormID',
          payload: '',
        }),
      ];
      if (payload.type === 'A') {
        yield [
          put({
            type: 'saveFormTitle',
            payload: 'Thêm mới',
          }),
          put({
            type: 'saveFormData',
            payload: {
              status: '1',
            },
          }),
        ];
      } else if (payload.type === 'E') {
        yield [
          put({
            type: 'saveFormTitle',
            payload: `Chỉnh sửa`,
          }),
          put({
            type: 'saveFormID',
            payload: payload.id,
          }),
          put({
            type: 'fetchForm',
            payload: {
              id: payload.id,
            },
          }),
        ];
      }
      if (callback) {
        callback();
      }
    },

    *fetchForm({ payload, callback }, { call, put }) {
      let response;
      try {
        response = yield call(partnersServices.get, payload.id, payload);
        if (response) transfromDocument(response);
        yield [
          put({
            type: 'saveFormData',
            payload: response,
          }),
        ];
      } catch (error) {
        console.log('*fetch -> error', error);
      }
      if (callback) {
        callback(response);
      }
    },

    *submit({ payload, callback }, { call, put, select }) {
      yield put({
        type: 'changeSubmitting',
        payload: true,
      });

      const params = { ...payload };
      const formType = yield select((state) => state.partners.formType);

      let success = false;
      let response;
      try {
        if (formType === 'E') {
          const id = yield select((state) => state.partners.formID);
          params.id = +id;
          response = yield call(partnersServices.update, id, params);
          console.log("IIIIIIIIIIIIIIIIIIIIII",id);
          success = true;
        } else {
          response = yield call(partnersServices.create, params);
          success = true;
        }
      } catch (error) {
        console.log("EEEEEEEEEEEEEEEEEEEEEEEEE",error)
        success = false;
      }

      yield put({
        type: 'changeSubmitting',
        payload: false,
      });
      console.log("SSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSS",success)
      if (success) {
        message.success('Thành công');
        yield put({
          type: 'changeFormVisible',
          payload: false,
        });
      }
      if (callback && success) {
        callback(response);
      }
    },
    *updateState({ payload, callback }, { call, put, select }) {
      const params = { ...payload };
      let id = params.id;
      try {
        const response = yield call(partnersServices.update, id, params);
        if (response === null) {
          message.success('Thay đổi trạng thái thành công');
        } else {
          message.error('Thay đổi trạng thái thất bại');
        }
      } catch (error) { }

      callback();
    },
    *sync({ payload, callback }, { call, put }) {
      try {
        let body = { ...payload };
        yield call(partnersServices.sync, body);
        message.success('Đồng bộ thành công');
      } catch (error) {
        message.error('Đồng bộ thất bại');
      }
      yield put({
        type: 'fetch',
      });
    },
    *pullVoucher({ payload, callback }, { call, put }) {
      try {
        let body = { ...payload };
        yield call(partnersServices.pullVoucher, body);
        message.success('Pull vouchers thành công');
      } catch (error) {
        message.error('Pull voucher thất bại');
      }
      yield put({
        type: 'fetch',
      });
    },
  },

  reducers: {
    save(state, action) {
      let pagi = get(action.payload, ['pagination'], {});
      pagi = omit(pagi, ['listAnchor']);
      const aPagi = get(action.payload, 'pagination', {});
      const sPagi = get(state.data, 'pagination', {});
      const listAnchor = Object.assign(
        {},
        get(aPagi, 'listAnchor', {}),
        get(sPagi, 'listAnchor', {}),
      );
      const pagination = Object.assign({}, sPagi, { listAnchor }, pagi);
      return {
        ...state,
        data: {
          ...state.data,
          list: action.payload.list,
          pagination,
        },
      };
    },
    changeFormVisible(state, { payload }) {
      return { ...state, formVisible: payload };
    },
    saveFormTitle(state, { payload }) {
      return { ...state, formTitle: payload };
    },
    saveFormType(state, { payload }) {
      return { ...state, formType: payload };
    },
    saveFormID(state, { payload }) {
      return { ...state, formID: payload };
    },
    saveFormData(state, { payload }) {
      return { ...state, formData: payload };
    },
    changeSubmitting(state, { payload }) {
      return { ...state, submitting: payload };
    },
  },
};
